import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const TabletIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Path
        d="M27.9998 18C27.9998 23.5228 23.5227 28 17.9998 28C12.477 28 7.99982 23.5228 7.99982 18C7.99982 12.4772 12.477 8 17.9998 8C23.5227 8 27.9998 12.4772 27.9998 18Z"
        fill="none"
        strokeWidth="2.2"
      />
      <Path
        d="M11.9998 20.1055L23.5909 16.9996"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </>
  ),
});

TabletIcon.displayName = "TabletIcon";
export { TabletIcon };
